import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureReducerKey, reducer } from './state/reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(featureReducerKey, reducer)],
})
export class SpinnerModule {}
